var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountShopMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,14h-7v-2c0-5.5136719-4.4858398-10-10-10S14,6.4863281,14,12v2H7c-1.6542969,0-3,1.3457031-3,3v20 c0,4.9628906,4.0375977,9,9,9h22c4.9624023,0,9-4.0371094,9-9V17C44,15.3457031,42.6542969,14,41,14z M16,12 c0-4.4111328,3.5888672-8,8-8s8,3.5888672,8,8v2H16V12z M42,37c0,3.859375-3.1401367,7-7,7H13c-3.8598633,0-7-3.140625-7-7V17 c0-0.5517578,0.4487305-1,1-1h7v4h2v-4h16v4h2v-4h7c0.5512695,0,1,0.4482422,1,1V37z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountShopMedium);
export default __webpack_public_path__ + "static/media/account-shop--medium.4aaf81d6c6e46a7a73c9aed127424425.svg";
export { ForwardRef as ReactComponent };